import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import User from "./user"
import Cities from "./cities"
import CbrUser from "./crm/cbrUser"
import crmExamLocation from "./crm/crmExamLocation"
import CrmCourseCities from "./crm/crmCourceCities"
import CrmProductNames from "./crm/crmProductNames"
import CourseLocations from "./crm/courseLocations"
import TrainingCategories from "./exercise/trainingCategories"
import ChapterCategories from "./exercise/chapterCategories"
import LandingCities from "./landing/cities"
import LandingReviews from "./landing/reviewFilters"
import CrmDrawer from "./crm/crmDrawer"
import CrmLabels from "./crm/crmLabels"
import LocationConfigurations from "./crm/LocationConfigurations"
import EmailTemplates from "./crm/crmEmailTemplates"
import SlotsType from "@/app/admin/modules/slots/core/slots-type-store"
import CMStore from "@/app/admin/modules/course_managment/core/cm-store"
import CrmCanidateColors from './crm/crmCandidateColors'
import allCourses from './crm/allCourses'
import storage from './storage'
import settings from './exercise/settings'

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user: User,
    cities: Cities,
    crmCandidateColors: CrmCanidateColors,
    cbrUser: CbrUser,
    crmDrawer: CrmDrawer,
    crmExamLocation: crmExamLocation,
    crmCourseCities: CrmCourseCities,
    crmProductNames: CrmProductNames,
    labels: CrmLabels,
    trainingCategories: TrainingCategories,
    chapterCategories: ChapterCategories,
    landingCities: LandingCities,
    landingReviews: LandingReviews,
    slotsType: SlotsType,
    emailTemplates: EmailTemplates,
    cm: CMStore,
    courseLocations: CourseLocations,
    locationConfigurations: LocationConfigurations,
    allCourses: allCourses,
    settings,
    storage
  }
})
